import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress';
import Meta from 'vue-meta';

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "home" */'./views/Home.vue')
    },
    {
      path: '/asesoramiento',
      name: 'emprendedores_asesoramiento',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "asesoramiento" */'./views/Counseling.vue')
    },
    {
      path: '/incubadora',
      name: 'incubadora',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "incubadora" */'./views/Incubator.vue')
    },
    {
      path: '/financiacion',
      name: 'financiacion',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "financiacion" */'./views/Financing.vue')
    },
    {
      path: '/emprendemos-contigo',
      name: 'emprendemos-contigo',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "emprendemos-contigo" */'./views/WeUnderstand.vue')
    },
    {
      path: '/equipo',
      name: 'emprendedores-equipo',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "group-foo" */'./views/OurTeam.vue')
    },
    {
      path: '/programa-aceleracion-proyectos',
      name: 'programa-aceleracion-proyectos',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "programa-aceleracion" */'./views/ProjectAcceleration.vue')
    },
    {
      path: '/recursos',
      name: 'recursos',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "recursos" */'./views/Resources.vue')
    },
    {
      path: '/recursos/aspectos-legales',
      name: 'resource-aspectos-legales',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-aspectos" */'./views/AspectosLegales.vue')
    },
    {
      path: '/recursos/publicaciones',
      name: 'resource-publicaciones',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-publicaciones" */'./views/Publicaciones.vue')
    },
    {
      path: '/recursos/ayudas-emprendedor',
      name: 'resource-ayudas-emprendedor',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-ayudas" */'./views/AyudasEmprendedor.vue')
    },
    {
      path: '/recursos/acuerdos-colaboracion',
      name: 'resource-acuerdos-colaboracion',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-acuerdos" */'./views/AcuerdosColaboracion.vue')
    },
    {
      path: '/recursos/ayudas-financiacion',
      name: 'resource-ayudas-financiacion',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-ayudas" */'./views/AyudasFinanciacion.vue')
    },
    {
      path: '/recursos/premios-emprendedor',
      name: 'resource-premios-emprendedor',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-premios" */'./views/PremiosEmprendedor.vue')
    },
    {
      path: '/recursos/simuladores-empresa',
      name: 'resource-simuladores-empresa',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-simuladores" */'./views/SimuladoresPlan.vue')
    },
    {
      path: '/recursos/revistas-emprendedores',
      name: 'resource-revistas-emprendedores',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "resource-revistas" */'./views/RevistasEmprendedores.vue')
    },
    {
      path: '/colaboradores',
      name: 'colaboradores',
      meta: {
        layout: 'entrepreneurs'
      },
      component: () => import(/* webpackChunkName: "colaboradores" */'./views/Collaborators.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */'./views/404.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      return new Promise(resolve => {
        if (to.matched.some(m => m.meta.scrollToTop)) {
          position.x = 0
          position.y = 0
        }
        this.app.$root.$once('triggerScroll', () => {
          resolve(position)
        })
      })
    }
  }
  
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  NProgress.done(true)
})

export default router;